import * as Types from '../../types/graphql.gen';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RegisterPatientIdCardMutationVariables = Types.Exact<{
  input: Types.RegisterPatientIdCardInput;
}>;


export type RegisterPatientIdCardMutation = { __typename?: 'Mutation', registerPatientIdCard: { __typename?: 'Patient', id: string, patientIdCardNumber: string | null } };

export type ProfileUnitFragment = { __typename?: 'Profile', avatar: string | null, id: string, birthday: string | null, building: string | null, city: string | null, district: string | null, firstname: string | null, firstnameJ: string | null, gender: Types.Gender | null, lastname: string | null, lastnameJ: string | null, name: string | null, nameJ: string | null, phone: string | null, postal: string | null, prefecture: string | null, lat: number | null, lng: number | null };

export type BaseProfileUnitFragment = { __typename?: 'Profile', id: string, birthday: string | null, building: string | null, city: string | null, district: string | null, firstname: string | null, firstnameJ: string | null, gender: Types.Gender | null, lastname: string | null, lastnameJ: string | null, name: string | null, nameJ: string | null, phone: string | null, postal: string | null, prefecture: string | null, lat: number | null, lng: number | null };

export const BaseProfileUnitFragmentDoc = gql`
    fragment BaseProfileUnit on Profile {
  id
  birthday
  building
  city
  district
  firstname
  firstnameJ
  gender
  lastname
  lastnameJ
  name
  nameJ
  phone
  postal
  prefecture
  lat
  lng
}
    `;
export const ProfileUnitFragmentDoc = gql`
    fragment ProfileUnit on Profile {
  avatar
  ...BaseProfileUnit
}
    ${BaseProfileUnitFragmentDoc}`;
export const RegisterPatientIdCardDocument = gql`
    mutation RegisterPatientIdCard($input: RegisterPatientIdCardInput!) {
  registerPatientIdCard(input: $input) {
    id
    patientIdCardNumber
  }
}
    `;
export type RegisterPatientIdCardMutationFn = Apollo.MutationFunction<RegisterPatientIdCardMutation, RegisterPatientIdCardMutationVariables>;

/**
 * __useRegisterPatientIdCardMutation__
 *
 * To run a mutation, you first call `useRegisterPatientIdCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterPatientIdCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerPatientIdCardMutation, { data, loading, error }] = useRegisterPatientIdCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterPatientIdCardMutation(baseOptions?: Apollo.MutationHookOptions<RegisterPatientIdCardMutation, RegisterPatientIdCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterPatientIdCardMutation, RegisterPatientIdCardMutationVariables>(RegisterPatientIdCardDocument, options);
      }
export type RegisterPatientIdCardMutationHookResult = ReturnType<typeof useRegisterPatientIdCardMutation>;
export type RegisterPatientIdCardMutationResult = Apollo.MutationResult<RegisterPatientIdCardMutation>;
export type RegisterPatientIdCardMutationOptions = Apollo.BaseMutationOptions<RegisterPatientIdCardMutation, RegisterPatientIdCardMutationVariables>;